import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { Bar } from 'react-chartjs-2';
import { BarElement, CategoryScale, Chart, Legend, LinearScale, Tooltip } from 'chart.js';
import messages from './messages';
Chart.register(BarElement, CategoryScale, LinearScale, Legend, Tooltip);
const SentRemindersChart = ({ series }) => {
    const intl = useIntl();
    const data = useMemo(() => ({
        labels: series.map(x => moment(x.date).format('dd D/M')),
        datasets: [
            {
                label: intl.formatMessage(messages.Automatic),
                data: series.map(x => x.automatic),
                backgroundColor: '#7564B6',
                maxBarThickness: 36,
            },
            {
                label: intl.formatMessage(messages.Manual),
                data: series.map(x => x.manual),
                backgroundColor: '#E0DBFD',
                maxBarThickness: 36,
            },
            {
                label: intl.formatMessage(messages.Failed),
                data: series.map(x => x.failed),
                backgroundColor: '#b80016',
                maxBarThickness: 36,
            },
        ],
    }), [series, intl]);
    const options = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'index' },
        scales: {
            x: { stacked: true, grid: { display: false } },
            y: { stacked: true, beginAtZero: true, ticks: { precision: 0 } },
        },
        plugins: {
            legend: { display: true, position: 'bottom', labels: { boxWidth: 12 } },
            tooltip: { displayColors: true },
        },
    }), []);
    return (_jsx("div", Object.assign({ className: "chart-container" }, { children: _jsx(Bar, { data: data, options: options }) })));
};
export default SentRemindersChart;
